
import React, { useEffect, useState } from 'react';
import { useAppContext } from '../../share-components/AppContext';
import { useNavigate } from 'react-router-dom';
import { ROUTE_CATEGORY_LIST } from '../../constants/routeConstants';
import * as Yup from 'yup';
import { ErrorMessage, Field, Form, Formik } from 'formik';
import AlertDialog from '../../share-components/AlertDialog';
import { createCategory } from '../../services/ManagementService';
import PageHeader from '../../share-components/PageHeader';
import { Button, Card } from 'react-bootstrap';
import FormTitle from '../../share-components/FormTitle';
import { SERVER_ERROR_MESSAGE } from '../../constants/commonConstants';

const CategoryCreate = () => {
    const { setLoading, setShowApiErrorMessage, setRouteNaviData } = useAppContext();
    const [showSuccessDialog, setShowSuccessDialog] = useState(false);
    const navigate = useNavigate();

    useEffect(() => {
        setRouteNaviData("CATEGORY >> NEW CATEGORY")
    }, []);

    const initialValues = {
        categoryName: '',
    };

    const validationSchema = Yup.object({
        categoryName: Yup.string()
            .max(30, 'Category Name must not exceed 30 characters.')
            .required('Category Name is required.'),
    });

    const onSubmit = async (form) => {
        setLoading(true);
        try {
            const response = await createCategory(form.categoryName);
            setShowSuccessDialog(true);
        } catch (error) {
            const errMsg = error?.response?.data?.errorMessage || SERVER_ERROR_MESSAGE;
            if(error.status !== 401 && error.status !== 403){
                setShowApiErrorMessage(errMsg);
            }
        } finally {
            setLoading(false);
        }
    };

    const handleSuccessDialogClose = () => {
        navigate(ROUTE_CATEGORY_LIST);
    }

    return (
        <>
            <PageHeader
                title={"New Category"}
            />
            <div style={{ minHeight: '80vh', display: 'flex', flexDirection: 'column', paddingBottom: '50px' }}>
                {/* Header */}

                {/* Login Form */}
                <Card style={{ width: '100%', maxWidth: '400px', padding: '20px', margin: '0 auto' }}>
                    <FormTitle title={"New Category"} isCenter={true}/>
                    <Card.Body>
                        <Formik initialValues={initialValues} validationSchema={validationSchema} onSubmit={onSubmit}>
                            {({ errors, isValid, dirty }) => {
                                const firstError = !dirty ? "Fill the required fields." : Object.values(errors)[0];
                                return (
                                    <Form>
                                        <div className="mb-1">
                                            <label className="form-label custom-label">Category Name*</label>
                                            <Field name="categoryName" type="text" className="form-control customInputControl" autoComplete="off" />
                                            <ErrorMessage name="categoryName" component="div" className="text-danger" />
                                        </div>

                                        <Button
                                            className="w-100 mt-2"
                                            type="submit"
                                            variant="primary"
                                        >
                                            Save
                                        </Button>

                                        <Button
                                            className="w-100 mt-2"
                                            type="button"
                                            variant="secondary"
                                            onClick={() => navigate(ROUTE_CATEGORY_LIST)}
                                        >
                                            Go to Category List
                                        </Button>
                                    </Form>
                                );
                            }}
                        </Formik>
                    </Card.Body>
                </Card>
            </div>
            <AlertDialog
                dialogId={'successDialog'}
                showDialog={showSuccessDialog}
                body={'New Category has been successfully created.'}
                onConfirm={handleSuccessDialogClose}
            />
        </>
    );
}

export default CategoryCreate;